import loadable from '@loadable/component';

import { hydrateOnDemand } from 'utils/hydrateOnDemand/hydrateOnDemand';

export const SearchHeroLoadable = hydrateOnDemand(
  loadable(() => import('./SearchHero'), {
    resolveComponent: (module) => module.SearchHero,
  }),
);
